import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { FastRegistrationComponent } from './view/fast-registration-screen/fast-registration.component';
import { TermsAndConditionsComponent } from './view/terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('./view/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'register',
    component: FastRegistrationComponent
  },
  {
    path: 'terms',
    component: TermsAndConditionsComponent
  },
  {
    path: '**',
    redirectTo: 'landing',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
